import {
	BooleanInput,
	Datagrid,
	DateField,
	List,
	ReferenceField,
	SearchInput,
	TextField,
	useListContext,
} from "react-admin";
import { useOrganPermission } from "../../permissions";

const filters = [
	<SearchInput source="q" alwaysOn />,
	<BooleanInput source="active" alwaysOn />,
];

const MissionGrid = () => {
	const { filterValues } = useListContext();

	return (
		<Datagrid bulkActionButtons={false} rowClick="show">
			<ReferenceField
				source="organ_id"
				reference="organs"
				link={false}
				sortable={false}
			>
				<TextField source="name" />
			</ReferenceField>
			<TextField source="unos_id" label="UNOS ID" sortable={false} />
			{filterValues.active ? (
				<DateField source="start_time" showTime sortable={false} />
			) : (
				<DateField source="end_time" showTime sortable={false} />
			)}
		</Datagrid>
	);
};

export const MissionList = () => {
	const { hasPermission } = useOrganPermission("missions.create");

	return (
		<List
			sort={{ field: "start_time", order: "DESC" }}
			filters={filters}
			filterDefaultValues={{ active: true }}
			hasCreate={hasPermission}
		>
			<MissionGrid />
		</List>
	);
};
